import React from "react";

export default ({ title }) => (
  <h1 id="page-header" className="page-header">
    {title}
  </h1>
);



// WEBPACK FOOTER //
// ./src/sc/ui/sites/oncall/components/PageTitle.js